import axios from 'axios';

// search function
/**
 * It takes a query string, a setSearch function, and a setSearchResult function as arguments, and
 * returns a function that takes an event as an argument.
 * @param q - the search query
 * @param setSearch - This is the setter function for the search state.
 * @param setSearchResult - This is the function that will be used to set the state of the
 * searchResult.
 */
export const searchFun = (q, setSearch, setSearchResult) => {
  axios
    .get('https://www.googleapis.com/youtube/v3/search', {
      params: {
        part: 'snippet',
        key: 'AIzaSyA7EmRv__qAVwoMzfs8p-iy5twmF0IvpeE',
        q: q,
      },
    })
    .then((res) => {
      // https://www.youtube.com/embed/' + res.data.items[0].id.videoId
      setSearch('');
      setSearchResult(res.data.items);
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

/**
 * It sends a command to the server to set the video id to the id of the video that was clicked on
 * @param e - the event object
 * @param socket - The socket object that was created in the useEffect hook.
 * @param setSearchResult - This is a function that sets the state of the search result.
 */
export const SetVideoId = (e, socket, setSearchResult) => {
  socket.emit('sendCommand', {
    command: 'setVideoId',
    param: e.target.id,
  });
  setSearchResult([]);
};
